import { createContext } from "react";
import { useChats } from "../hooks/pages/useChats";
import useChatbotConfig from "../hooks/useChatbotConfig";
const ChatContext = createContext({});

export const ChatProvider = ({ children }) => {
  const { userRole, user, botSelected } = useChatbotConfig();
  // const data = useChats(userRole, user, botSelected?.output_buffer);
  const data = useChats(userRole);
  return <ChatContext.Provider value={data}>{children}</ChatContext.Provider>;
};

export default ChatContext;
